import { Maybe, AnyObject, ObjectSchema } from 'yup';

export type FormValues<S extends ObjectSchema<Maybe<AnyObject>>> = NonNullable<ReturnType<S['cast']>>;

export const getInitialFormValues = <T extends Maybe<AnyObject>>(
    schema: ObjectSchema<T>,
    values?: Partial<FormValues<ObjectSchema<T>>> | AnyObject,
) => {
    const result = schema.cast(
        {
            ...schema.getDefault(),
            ...values,
        },
        { stripUnknown: true, assert: false },
    );

    // Undefined fields need to be explicitly set so formik can properly set them as touched when submitting the form
    if (result) {
        Object.keys(schema.fields).forEach((key) => {
            if (!Object.prototype.hasOwnProperty.call(result, key)) {
                result[key] = undefined;
            }
        });
    }

    return result;
};
